import React, { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function GraduationCapIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path d="M.75 9 12 3l11.25 6L12 15 .75 9Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"
            strokeWidth="1.5" />
      <path d="M17.625 22.5V12L12 9" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"
            strokeWidth="1.5" />
      <path
        d="M20.625 10.396v5.119a.729.729 0 0 1-.15.44c-.628.844-3.291 3.92-8.475 3.92-5.184 0-7.846-3.075-8.475-3.92a.732.732 0 0 1-.15-.44v-5.12"
        stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
    </BaseIcon>
  );
}
